<template>
  <div>
    <BodyLoader :loading="firstLoad"></BodyLoader>

    <div class="dvModals">
      <div id="modal-send-print" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Send Email
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Email Address</label>
                <input v-model="printSendTo" class="browser-default defaultModal-input" placeholder="e.g. juan.delacruz@ayalaland-intl.com" type="text" />
                <div class="defaultModal-helper-text">
                  * Required
                </div>
                <div class="defaultModal-helper-text">
                  Multiple email addresses should be , separated. For ex: j@email.com, m@email.com
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!sendingPrint"
            @click="sendlPrint()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Send
          </a>

          <a
            v-if="sendingPrint"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Sending...
          </a>

          <a
            :disabled="sendingPrint"
            @click="closeModal('modal-send-print')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->
    </div>



    <div class="row dvQuickGlance forMember" v-if="false">


      <div class="col s12 m5 row valign-wrapper dvQuickGlance-main">

        <div class="col s12 dvQuickGlance-info valign-wrapper">
          <div class="dvQuickGlance-image">
            <div class="dvQuickGlance-image-placer flexCenterAll"><span class="icon-fs_user"></span></div>
            <img class="dvQuickGlance-image-pic responsive-img" :src="member.photo" v-show="member.photo.length > 0"/>
            <a class="dvQuickGlance-image-link flexCenterAll" href="#"><span class="icon-editor_camera"></span></a>
          </div> <!-- dvQuickGlance-image -->
          <div class="dvQuickGlance-user">
            <div class="dvQuickGlance-user-welcome"><strong>{{ $store.getters.formatFullName(member.first_name, member.last_name) }}</strong></div>
            <div class="dvQuickGlance-user-team">{{ team.channel }} - {{ team.team }}</div>
            <div class="dvQuickGlance-user-position">{{ member.position }}</div>
          </div> <!-- dvQuickGlance-user -->
        </div> <!-- dvQuickGlance-info -->
      </div> <!-- dvQuickGlance-main -->

      <div class="col s12 m7 dvQuickGlance-tabs">
        <div class="dvTabs">
          <div
            :class="{ isActive: this.$route.params.status == 'valid' ? true : false }"
            @click="filterByReferralStatus('valid')"
            class="waves-effect waves-light dvTabs-item isValid">
            Valid<div class="dvTabs-tally">{{ summary.valid }}</div>
          </div>
          <div
            :class="{ isActive: this.$route.params.status == 'pending' ? true : false }"
            @click="filterByReferralStatus('pending')"
            class="waves-effect waves-light dvTabs-item isPending">
            Pending<div class="dvTabs-tally">{{ summary.pending }}</div>
          </div>
          <div
            :class="{ isActive: this.$route.params.status == 'expiring' ? true : false }"
            @click="filterByReferralStatus('expiring')"
            class="waves-effect waves-light dvTabs-item isExpiring">
            Expiring<div class="dvTabs-tally">{{ summary.expiring }}</div>
          </div>
          <div
            :class="{ isActive: this.$route.params.status == 'archive' ? true : false }"
            @click="filterByReferralStatus('archive')"
            class="waves-effect waves-light dvTabs-item isArchive">
            Archive<div class="dvTabs-tally">{{ summary.archive }}</div>
          </div>
        </div> <!-- dvTabs -->
      </div>
    </div> <!-- dvQuickGlance -->

    <div class="row dvContent">

      <div class="col s12 dvContentMain">
        <div class="dvSectionTitleOpts hide">
          <div class="dvSectionTitleOpts-title">
            <span class="icon-fs_user"></span>Add New Client
          </div> <!-- dvSectionTitleOpts-title -->
        </div> <!-- dvSectionTitleOpts -->

        <div class="dvClientForm">

          <div class="dvClientFormBox">
            <div class="dvClientFormBox-header valign-wrapper">
              <div class="dvClientFormBox-header-title">
                My Activity Log
              </div>
            </div>
            <div class="dvClientActivity">
              <div
                v-if="logsLoading"
                class="row dvClientActivity-item">
                <div class="col s12 m12">
                  Please wait...
                </div>
              </div>
              <div
                v-if="noRecordFound && !logsLoading"
                class="row dvClientActivity-item">
                <div class="col s12 m12">
                  No Activity Logs
                </div>
              </div>

              <div
                v-for="(history, index) in activities" :key="index"
                class="row dvClientActivity-item">

                <div class="col s4 m3">
                  <div class="dvClientActivity-item-date"><span class="icon-content_activity"></span>{{ history.created_at | moment("MMMM D, YYYY") }}</div>
                </div>
                <div class="col s8 m9">
                  <div class="dvClientActivity-item-log">
                      <div v-html="history.details"></div>
                      <div>{{ history.created_at | moment("MM/DD/YY, hh:mm A") }}</div>
                  </div>
                </div>

              </div><!-- dvClientActivity-item -->

            </div><!-- dvClientActivity -->
          </div> <!-- dvClientFormBox -->


        </div> <!-- dvClientForm -->

      </div> <!-- dvContentMain -->

      <div class="col s12 dvContentTools formSubmit">
        <div class="dvContentTools-fx"></div>
        <div class="dvContentTools-content">
          <!-- <a href="#" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll"><span class="icon-nav_chevron_left"></span>Previous</a>
          <a href="#" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">Next<span class="icon-nav_chevron_right"></span></a> -->
        </div> <!-- dvContentTools-formSubmit -->

        <div class="dvContentTools-page">
          <a @click="emailPrint('modal-send-print')" href="javascript:void(0)" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-content_email"></span><div class="hide-on-small-only">Email</div></a>
          <a @click="printJS()" href="javascript:void(0)" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_print"></span><div class="hide-on-small-only">Print</div></a>
          <ToTop></ToTop>
        </div>

      </div>

    </div> <!-- dvContent -->
    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
  </div>
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import BodyLoader from '@/components/BodyLoader.vue'
  import printJS from 'print-js'
  import M from 'materialize-css'
  import ToTop from '@/components/totop/ToTop.vue'

  export default {
    name: 'my-activity',
    data: () => ({
      printSendTo: '',
      sendingPrint: false,
      domain: '',
      id: 0,
      referralSummary: [],
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      team: {},
      summary: {
        valid: '0',
        pending: '0',
        expiring: '0',
        archive: '0'
      },
      member: {},
      loading: false,
      logsLoading: false,
      activities: [],
      firstLoad: true,
      loadedCnt: 0,
      noRecordFound: false
    }),
    watch: {
      loadedCnt: function() {
        if(this.loadedCnt == 1){
          this.firstLoad = false
        }
      }
    },
    computed: {

    },
    methods: {
      printJS (){
        printJS(this.domain+'/api/my-activity?request_type=print');
      },
      closeModal (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.close();

        this.printSendTo = ''
      },
      emailPrint (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      sendlPrint (){
        if(this.printSendTo == ''){
          this.showMessage('The email field is required.', 'sb-failed')
          return false
        }

        if(this.sendingPrint){
          return false
        }

        let self = this
        self.sendingPrint = true

        let url = '/api/my-activity?request_type=mail&send_to='+this.printSendTo
        this.$http.plain.get(url)
          .then(response => {
            if(response.data == 'sent'){
              this.showMessage('Email has been sent', 'sb-success')
            }
            this.printSendTo = ''
            this.closeModal('modal-send-print')
          })
          .catch(error => {
            if (error.response.status === 500) {
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }else{
              this.showMessage(error.response.data.messages.error, 'sb-failed')
            }
          })
          .then(function () {
            self.sendingPrint = false
          })
      },
      filterByReferralStatus (filterStatus){
        this.$router.push({ name: 'team_member', params: { id: this.id, status: filterStatus } })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      getActivities () {
        let self = this
        this.logsLoading = true
        this.noRecordFound = false
        this.$http.plain.get('api/my-activity')
          .then(response => {

            this.activities = response.data;

            if(this.activities.length == 0){
              this.noRecordFound = true
            }

          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.logsLoading = false
            self.loadedCnt++
          })
      },
      getMemberDetails () {
        if(this.loading){
          return false;
        }

        let self = this
        this.loading = true
        this.member = {};

        this.$http.plain.get('api/members/'+this.id)
          .then(response => {
            this.team = response.data.team
            this.summary = response.data.summary
            this.member = response.data.member
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.loading = false
            self.loadedCnt++
          })
      }
    },
    mounted() {
      this.domain = this.$store.getters.getApiURL
      this.id = this.$store.getters.getCurrentUserDetails.id
      // this.getMemberDetails()
      this.getActivities()
    },
    components: {
      SnackBar,
      BodyLoader,
      ToTop
    }
  }
</script>
